import { DateTime } from 'luxon'
import { getType } from 'typesafe-actions'

// @ts-ignore
import { setEntityModel } from '../api/apiClient'
import { actionCreators as loginActionCreators, LoginActions } from '../login'
import { actionCreators as meActionCreators, MeActions } from '../me'
import { actionCreators as docsActionCreators } from '../docs'
import { AllowedIncludeEntity, Entity } from 'types/Entity'
import { LSP, ExtendedVehicleConfiguration } from 'types/LSP'
import { LoadList } from '../../types/List'
import { Dispatch } from 'redux'

// Types
export interface State extends LSP {
  isFetching: boolean
  vehicleConfigurations: ExtendedVehicleConfiguration[]
}

// Constants
export const ENTITY: Entity = 'lsp'
export const INCLUDE_ENTITY: AllowedIncludeEntity = 'lsp'

// Model and initial state
export const Model: LSP = {
  country_code: '',
  eligible_vehicles: {},
  id: '',
  name: '',
  vehicle_classes: []
}

export const initialState: State = {
  ...Model,
  isFetching: false,
  vehicleConfigurations: []
}

// Reducer
export default function reducer (
  state: typeof initialState = initialState,
  action: MeActions | LoginActions
) {
  switch (action.type) {
    case getType(meActionCreators.loadMeRequest):
      return {
        ...state,
        isFetching: true
      }
    case getType(meActionCreators.loadMeSuccess): {
      const lsp: LSP = action.payload.lsp
      return {
        ...state,
        isFetching: false,
        ...lsp,
        vehicleConfigurations: getVehicleConfigurationList(
          lsp.eligible_vehicles
        )
      }
    }
    case getType(meActionCreators.loadMeFailure):
      return {
        ...state,
        isFetching: false
      }
    case getType(loginActionCreators.logoutAction):
    case getType(loginActionCreators.sessionExpiredAction):
      return {
        ...initialState
      }
    default:
      return state
  }
}

// Side effects
setEntityModel(ENTITY, Model)

function getYearsOfProduction (maxAgeInYears: number) {
  const today = DateTime.local().year
  const years = []
  for (let i = 0; i < maxAgeInYears; i++) {
    years.push(String(today - i))
  }
  return years
}

export function getVehicleConfigurationList (
  eligibleVehicles: typeof Model['eligible_vehicles']
): ExtendedVehicleConfiguration[] {
  return Object.entries(eligibleVehicles).reduce(
    (listOfVehicles, [serviceClass, vehiclesByServiceClass]) => {
      const vehicleConfigurationWithServiceClass: ExtendedVehicleConfiguration[] = vehiclesByServiceClass.map(
        vehicleConfiguration => ({
          colors: vehicleConfiguration.colors,
          productionYears: getYearsOfProduction(vehicleConfiguration.max_age),
          serviceClass,
          model: vehicleConfiguration.vehicle_model
        })
      )
      return [...listOfVehicles, ...vehicleConfigurationWithServiceClass]
    },
    [] as ExtendedVehicleConfiguration[]
  )
}

export const actionCreators: {
  loadLspDocs: LoadList
} = {
  // @ts-ignore
  loadLspDocs: ({ resourceId } = {}) => {
    if (!resourceId) {
      throw new Error('No LSP ID received!')
    }

    // There is no getState type available for typescript yet
    // @ts-ignore
    return (dispatch: Dispatch, getState) =>
      docsActionCreators.loadDocs({
        dispatch,
        entity: ENTITY,
        state: getState().docs,
        resourceId
      })
  }
}
